import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    Grid,
    IconButton,
} from '@material-ui/core';
import { Delete as DeleteIcon } from '@material-ui/icons';
import InputTitle from '../InputTitle';
import { getRollingPeriodUnitLabel } from '../../../../Enums/Helpers/LabellingHelper';
import InputDisclaimer from '../InputDisclaimer'

/**
 * @param {{
 *  maxHoursInRollingPeriodRules: ApiAdmin.IMaxHoursInRollingPeriodRule[],
 *  onDelete: Function,
*   isDisabled?: boolean,
 * }}
 */
function MaxHoursPerRollingPeriodRulesSummary(props) {
    const { maxHoursInRollingPeriodRules, onDelete, isDisabled = false } = props;
    const { t } = useTranslation('employmentBillboard', { keyPrefix: 'settings.ruleSet.scheduleRulesStep.rollingPeriodRulesSummary' });

    return (
        <>
            <InputTitle>{t('title')}</InputTitle>
            {maxHoursInRollingPeriodRules.map((x, index) => (
                <Grid
                    container
                    justifyContent="space-evenly"
                >
                    <Grid
                        item
                        xs={11}
                        className="mhrprs-awarding-rule-summary"
                    >
                        <span className="text-lg-medium">
                            {t('ruleSummary', { count: x.maxHoursInRollingPeriod, periodValue: x.rollingPeriodNumber, periodUnit: getRollingPeriodUnitLabel(x.rollingPeriodUnit) } )}
                        </span>
                    </Grid>
                    <Grid
                        item
                        xs={1}
                        className="mhrprs-summary-edit-delete-btns"
                        justifyContent="flex-end"
                    >
                        <IconButton
                            onClick={() => onDelete(index)}
                            className="mhrprs-edit-and-delete-btn"
                            disabled={isDisabled}
                        >
                            <DeleteIcon />
                        </IconButton>
                    </Grid>
                </Grid>
            ))}
            <InputDisclaimer>{t('disclaimer')}</InputDisclaimer>
        </>
    );
};

export default MaxHoursPerRollingPeriodRulesSummary;